import React from 'react';

import GlobalFonts from '~/theme/fonts.web';

export const GlobalStyle = () => {
  return <GlobalFonts />;
};
